import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faArrowDownToBracket} from '@netx/core-icons';
import {canCreatePdfFromCurrentCart} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

export const cartActionCreatePDFDownloadIcon = faArrowDownToBracket;

/**
 * Create and download pdf from cart
 * @param params
 * @returns Action
 */
export const cartActionCreatePDFDownload = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'cart-create-pdf-download',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.CREATE_PDF_DOWNLOAD),
	enableTest: () => canCreatePdfFromCurrentCart(),
	icon: cartActionCreatePDFDownloadIcon,
	get label() {
		return CART_CURRENT_ACTION_LABELS.CREATE_PDF_DOWNLOAD;
	},
	...params,
});

export default cartActionCreatePDFDownload;
